import IndexSubview from './subviews';
import MyCarsSubview from './subviews/my-cars';
import ResultSubview from './subviews/result';
import VinLookupSubview from './subviews/vin-lookup';
import { scrollToElement } from '../../../../utils/dom';

export default class ServicePlansView {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.service-plans-view');        
        this.router = parent.router;
        this.subviews = {
            'index': new IndexSubview(this),
            'my-cars': new MyCarsSubview(this),
            'vin-lookup': new VinLookupSubview(this),
            'result': new ResultSubview(this),
        };
        this.bind();
    }

    bind() {
        window.HONDA.MyAccount2.addEventListener('login', () => this.getCars());
    }

    async getCars() {
        const result = await window.HONDA.MyAccount2.client.getDsrDetails();
        const cars = result?.success ? result?.data : [];
        this.subviews.index.toggleMyCar(cars.length > 0);
        this.subviews['my-cars'].populate(cars);
    }

    scrollToTop() {
        scrollToElement(this.el, 0);
    }

    show() {
        this.el.classList.remove('hide');
        const view = this.router.params.get('view') ?? 'index';
        const targetView = this.subviews[view];
        Object.values(this.subviews).forEach((v) => v.hide());
        targetView?.show();  
        this.scrollToTop();      
    }

    hide() {
        this.el.classList.add('hide');
    }
}
